export enum HomeComponentType {
  LandingWidget = 'LandingWidget',
  RatingWidget = 'RatingWidget',
  StackCard = 'StackCard',
  ProductBanner = 'ProductBanner',
  CouponUnlockBanner = 'CouponUnlockBanner',
  DownloadAppBanner = 'DownloadAppBanner',
}

export enum NewHomePageComponent {
  Hero = 'HeroComponent',
  DriveHero = 'DriveHeroComponent',
  MobileStickyCarousel = 'MobileStickyCarousel',
  DesktopStickyCarousel = 'DesktopStickyCarousel',
  Safebuy = 'SafebuyComponent',
  BannerCarousel = 'BannerCarousel',
  VideoPlayer = 'VideoPlayerComponent',
  CustomerStories = 'CustomerStoriesComponent',
  PartnershipBanner = 'PartnershipBannerComponent',
  RatingGrid = 'RatingGridComponent',
  Trust = 'TrustComponent',
  AppService = 'AppServiceComponent',
  Footer = 'HomepageFooter',
  DriveHeroNew = 'DriveHeroComponentNew',
}
